<script>
import { mapState } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';
import { getMyOfficials } from '../api/lobbying';
import { RoleTypes } from '../constants';

export default {
  name: 'CpMyRepresentatives',
  components: {
    CpBox: require('@resources/js/box').default,
    CpButton: require('../button').default,
    VueSimpleSpinner: require('../vue-simple-spinner').default,
    CpMemberComponent: require('../components/member/MemberComponent').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginTop: require('../directives/margins').marginTop,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
    marginLeft: require('../directives/margins').marginLeft,
  },
  mounted() {
    this.checkAndFetchRepresentatives();
  },
  watch: {
    isAddressCompleted() {
      this.checkAndFetchRepresentatives();
    },
  },
  data() {
    return {
      RoleTypes,
      representatives: [],
      loading: false,
    };
  },
  computed: {
    isAddressCompleted() {
      return this.userProfileData?.address_state && this.userProfileData?.address_zip;
    },
    ...mapState(useUserStore, ['isUserLogin', 'userProfileData']),
  },
  methods: {
    checkAndFetchRepresentatives(val) {
      if (this.userProfileData?.address_state && this.userProfileData?.address_zip) {
        this.handleMyRepresentatives();
      }
    },
    async handleMyRepresentatives() {
      this.loading = true;
      try {
        const response = await getMyOfficials();
        this.representatives = response.officials;
      } catch (error) {
        console.error('Error fetching my representatives:', error);
      } finally {
        this.loading = false;
      }
    },
    redirectTo(path) {
      window.location.href = path;
    },
    repData(member) {
      return {
        id: member.id,
        image: member.large_img,
        fullname: member.name,
        description: member.office_name,
        permalink: member.permalink,
        role: RoleTypes.OFFICIAL,
      };
    },
  },
};
</script>

<template>
  <CpBox outlined class="myRepContainer">
    <h4 class="myRepresentativesTitle">
      <i class="fal fa-users-class neutral-2-color"></i>
      <span class="subhead neutral-2-color" v-margin-left="0.5">{{ $root.isSmallDesktop ? 'My Rep...' : 'My Representatives' }}</span>
    </h4>
    <div v-if="!isUserLogin">
      <cp-button thin noborder @click="redirectTo('/user/login')">Enter your address to see your Representatives</cp-button>
    </div>
    <div v-else-if="!userProfileData?.address_state || !userProfileData?.address_zip">
      <cp-button thin noborder @click="redirectTo('/user/settings')">Enter your address to see your Representatives</cp-button>
    </div>
    <div v-else>
      <div v-if="loading" class="spinner">
        <vue-simple-spinner />
      </div>
      <div v-else v-for="rep in representatives" :key="rep.id" v-margin="0.5">
        <CpMemberComponent :member="repData(rep)" />
      </div>
    </div>
  </CpBox>
</template>

<style scoped>
.myRepContainer {
  padding: 18px;
}
.myRepresentativesTitle,
.spinner {
  display: flex;
  align-items: center;
}
.myRepresentativesTitle span {
  font-family: var(--sans-font);
  font-size: 17px;
  font-weight: bold;
}
.spinner {
  justify-content: center;
}
</style>
